import React from 'react';

// Plunger logo as base64 PNG
export const PLUNGER_LOGO_SRC = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEP0lEQVR4nO2XXWwUVRTHpwjYimn8hAL6IGhVQkwVgy2d6Wqsxgc07p1OoohifEAfIEjYewFjXF806oNK4kd8MvFF4oMPthQ1+FGDEVEEQbr3tourYrvsvRNbu3O3prYeM0sLO+POsNtud7ZxT3Jedk/O+f/ux7lnFKVq/0MDw7gojSLtUifvWTrptzoijylzySTCX0idgMv3j6JdK5S5YBbCOA8AWIhkpI6fByO6UKlkkw/gZRYi4/kgso7w8YwRaVEq2SQiBzwB7N3QyT/2HRk2tl+hVKJZKPK4H0AOyIBSiWY+srXe0rEsBEKpVLN0sje7yuu3wJ9N7TB8y13BAWhMgJ+748HYXme1P/HGHw0rQNTMA6EoIBbWggzvqFwA+wHLGDtVqZN3pE5GZDgC5sV1Z8VP+khLuPIAmo4NgkTkJYlI0i1uaOVtDoCh5TdWBsDak2fgukO/Qt3HcVA6Y54XNH3nxqxws/5KGL65FdL3bQ4OoLk3BTccPg31B/qyonM9f4vEpy2E94y0bxoMrAvZlzHTgY3LPz8FNV1O0R4AQ/YDJdHO++07Yeewx4eyAjimSYTT2SIewm2f1xWz70CnPXXC+ugl7nyjD0ZWTr68swsgjV1r7C2XOj6TWyC54dn/Cu+KwWWf9UPjd79DS4xDKJGo9ctt6fibWQEYQbtvsrfY0kncq0D0tQ/PCV/0aR80Hkz81XwiaeZe6lZmhn0XB5EtJQOwp0WJ8DZLJwcLeepv/+jHsWu//gXWHE9mxapMvK5RscfVmT7wXShj99UWImMlAfAddc85Ni1E3j6x9dV7NSoyuWJVZt7RGjebHb9RMbo2btb7LhwinaXZAa/JEOFRu4jddaY+OlQqHnWsNBWnFICayf/6XBAb/epmOshDJQewEJ7IHiWEN9sTpDtWY6LbBfDC1H8q5S+6APb51YVN0VqJ8HBpAcLPLPWKC9GBqzTGxy40B50/Wvzvlv7k4gvUfvf84pFxicgnMwLwi9Ni4qlCxef4k3450zq+29Lx4WwTMSINRYsvBkCloqdoACq+nJaoUgOsi4llGuUTxQPwiVDcvEYJGkBjIuISdsgrVqX829zYNiZ2KEEDqFQccYiK8W1esRrlT7t24nslSIBQX+p697FoZuZyT4BevlSlfNzRkXp5Y2AAKuXRaXQfZ0ul/LnAADTKT84YgPFYIABtcX7rTMVP+TqWaio7gEr5K6UC0Bh/ubwAADUqEwnXUXi40LxtcbHBdQ9+mxr8ygLQxrjmelVl6KfUpYXmvedYcpHKhJWbo5Wm1LIBaIy/5QJ4v9jcKhN7XcfozZKKPys0b9eABfup47t31Q8DRZ/7VUcGHDkWdNNs7nyxJQVYfXTQUXh+N4NWOq3+D/P3MUeu1UcHZx9gcU/CUbThq8S0u8+Snp8duZb0JGYfIAhXqgBsju5A1apWNWXO2L8eIRvjMqmxeQAAAABJRU5ErkJggg==".replace(/\s/g, '');

// Orange filter to match theme color #E87A5D
const ORANGE_FILTER = 'sepia(100%) saturate(500%) brightness(100%) hue-rotate(-10deg)';

const PlungerLogo = ({ className = "w-8 h-8", style = {} }) => (
  // We move the filter to a span/div wrapper to avoid Firefox rendering bugs
  // and ensure the image is set to block to prevent baseline alignment issues
  <span 
    className={`inline-block ${className}`} 
    style={{ 
      filter: ORANGE_FILTER, 
      lineHeight: 0, 
      ...style 
    }}
  >
    <img 
      src={PLUNGER_LOGO_SRC} 
      alt="PlungerXcel" 
      className="w-full h-full object-contain display-block"
      // Force hardware acceleration for Firefox
      style={{ transform: 'translateZ(0)' }} 
    />
  </span>
);

export default PlungerLogo;